"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _desc, _value, _class, _class2, _desc2, _value2, _class3;

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tposition: relative;\n\tline-height: 1;\n\tmax-height: ", "em;\n\tdisplay: inline-block;\n\toverflow: visible;\n\tcursor: pointer;\n\twidth: 10em;\n\tflex: 7;\n"], ["\n\tposition: relative;\n\tline-height: 1;\n\tmax-height: ", "em;\n\tdisplay: inline-block;\n\toverflow: visible;\n\tcursor: pointer;\n\twidth: 10em;\n\tflex: 7;\n"]),
    _templateObject2 = (0, _taggedTemplateLiteral3.default)(["\n\tbackground: ", ";\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tpadding: ", ";\n\tposition: relative;\n\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n\n\t&:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: ", "em;\n\t\tright: ", "em;\n\t\tborder: ", "em solid transparent;\n\t\tborder-top-width: ", "em;\n\t\tborder-bottom-width: 0;\n\t\tborder-top-color: ", ";\n\t\theight: ", "em;\n\t\twidth: ", "em;\n\t}\n"], ["\n\tbackground: ", ";\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tpadding: ", ";\n\tposition: relative;\n\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n\n\t&:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\ttop: ", "em;\n\t\tright: ", "em;\n\t\tborder: ", "em solid transparent;\n\t\tborder-top-width: ", "em;\n\t\tborder-bottom-width: 0;\n\t\tborder-top-color: ", ";\n\t\theight: ", "em;\n\t\twidth: ", "em;\n\t}\n"]),
    _templateObject3 = (0, _taggedTemplateLiteral3.default)(["\n\tbackground: ", ";\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tbox-shadow: inset 0 -2em 2em -2em ", ";\n\tdisplay: ", ";\n\tleft: 0;\n\tmax-height: 60vh;\n\toverflow-y: scroll;\n\tpadding: 0;\n\tposition: absolute;\n\tright: 0;\n\ttop: 100%;\n\tz-index: 10;\n\n\t&.scrolled {\n\t\tbox-shadow: none;\n\t}\n"], ["\n\tbackground: ", ";\n\tborder-radius: ", ";\n\tborder: 1px solid ", ";\n\tbox-shadow: inset 0 -2em 2em -2em ", ";\n\tdisplay: ", ";\n\tleft: 0;\n\tmax-height: 60vh;\n\toverflow-y: scroll;\n\tpadding: 0;\n\tposition: absolute;\n\tright: 0;\n\ttop: 100%;\n\tz-index: 10;\n\n\t&.scrolled {\n\t\tbox-shadow: none;\n\t}\n"]),
    _templateObject4 = (0, _taggedTemplateLiteral3.default)(["\n\t", " overflow: hidden;\n\tpadding: ", "em ", "em;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n"], ["\n\t", " overflow: hidden;\n\tpadding: ", "em ", "em;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n\n\t&:hover {\n\t\tbackground: ", ";\n\t}\n"]),
    _templateObject5 = (0, _taggedTemplateLiteral3.default)(["\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin: ", ";\n"], ["\n\talign-items: center;\n\tdisplay: flex;\n\tflex-direction: row;\n\tmargin: ", ";\n"]),
    _templateObject6 = (0, _taggedTemplateLiteral3.default)(["\n\tpadding-right: 1em;\n\tflex: 3;\n\ttext-align: right;\n"], ["\n\tpadding-right: 1em;\n\tflex: 3;\n\ttext-align: right;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _autobindDecorator = require("autobind-decorator");

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _reactDom = require("react-dom");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _polished = require("polished");

var _getters = require("../getters");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
	var desc = {};
	Object['ke' + 'ys'](descriptor).forEach(function (key) {
		desc[key] = descriptor[key];
	});
	desc.enumerable = !!desc.enumerable;
	desc.configurable = !!desc.configurable;

	if ('value' in desc || desc.initializer) {
		desc.writable = true;
	}

	desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		return decorator(target, property, desc) || desc;
	}, desc);

	if (context && desc.initializer !== void 0) {
		desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		desc.initializer = undefined;
	}

	if (desc.initializer === void 0) {
		Object['define' + 'Property'](target, property, desc);
		desc = null;
	}

	return desc;
}

// --------------------------------------------------

var getWrapperMaxHeight = _ramda2.default.pipe(_getters.getPaddingVertical, _ramda2.default.multiply(2), _ramda2.default.add(1));

var getWrapperMaxWidth = _ramda2.default.pipe(_getters.getPaddingHorizontal, _ramda2.default.multiply(2), _ramda2.default.add(1));

// --------------------------------------------------

var Wrapper = _styledComponents2.default.div(_templateObject, getWrapperMaxHeight);

var getTriggerPadding = function getTriggerPadding(props) {
	return [(0, _getters.getPaddingVertical)(props), getWrapperMaxWidth(props), (0, _getters.getPaddingVertical)(props), (0, _getters.getPaddingHorizontal)(props)].join("em ") + "em";
};

var Trigger = _styledComponents2.default.div(_templateObject2, (0, _getters.getColor)("lightgray"), _getters.getBorderRadius, (0, _getters.getColor)("gray"), getTriggerPadding, (0, _getters.getColor)("midgray"), function (props) {
	return (0, _getters.getPaddingVertical)(props) + (1 - (0, _getters.getArrowWidth)(props)) / 2;
}, _getters.getPaddingHorizontal, function (props) {
	return (0, _getters.getArrowWidth)(props) / 2;
}, _getters.getArrowWidth, (0, _getters.getColor)("darkgray"), _getters.getArrowWidth, _getters.getArrowWidth);

var getContentBorderRadius = function getContentBorderRadius(props) {
	return ["0", "0", (0, _getters.getBorderRadius)(props), (0, _getters.getBorderRadius)(props)].join(" ");
};

var Content = _styledComponents2.default.div(_templateObject3, (0, _getters.getColor)("lightgray"), getContentBorderRadius, (0, _getters.getColor)("gray"), _ramda2.default.path(["theme", "colors", "darkgray"]), function (p) {
	return p.active ? "block" : "none";
});

var getOptionBackgroundColor = function getOptionBackgroundColor(props) {
	return props.active ? "background-color: " + (0, _polished.lighten)(0.4, (0, _getters.getColor)("primary")(props)) + ";" : "";
};

var Option = _styledComponents2.default.div(_templateObject4, getOptionBackgroundColor, _getters.getPaddingVertical, _getters.getPaddingHorizontal, (0, _getters.getColor)("midgray"));

var getOuterWrapperMargin = function getOuterWrapperMargin(props) {
	return [(0, _getters.getMarginVertical)(props), (0, _getters.getMarginRight)(props), (0, _getters.getMarginVertical)(props), (0, _getters.getMarginLeft)(props)].join("em ") + "em";
};

var OuterWrapper = _styledComponents2.default.div(_templateObject5, getOuterWrapperMargin);

var Label = _styledComponents2.default.div(_templateObject6);

// --------------------------------------------------

var DropdownOption = (_class = function (_React$Component) {
	(0, _inherits3.default)(DropdownOption, _React$Component);

	function DropdownOption() {
		(0, _classCallCheck3.default)(this, DropdownOption);
		return (0, _possibleConstructorReturn3.default)(this, (DropdownOption.__proto__ || Object.getPrototypeOf(DropdownOption)).apply(this, arguments));
	}

	(0, _createClass3.default)(DropdownOption, [{
		key: "onClick",
		value: function onClick() {
			this.props.onClick({
				value: this.props.value || this.props.children,
				target: {
					value: this.props.value || this.props.children
				}
			});
		}
	}, {
		key: "render",
		value: function render() {
			return _react2.default.createElement(Option, (0, _extends3.default)({}, this.props, { onClick: this.onClick }));
		}
	}]);
	return DropdownOption;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, "onClick", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype)), _class);

var Dropdown = (0, _reactOnclickoutside2.default)(_class2 = (_class3 = function (_React$Component2) {
	(0, _inherits3.default)(Dropdown, _React$Component2);

	function Dropdown(props) {
		(0, _classCallCheck3.default)(this, Dropdown);

		var _this2 = (0, _possibleConstructorReturn3.default)(this, (Dropdown.__proto__ || Object.getPrototypeOf(Dropdown)).call(this, props));

		_this2.state = {
			active: false,
			scrolled: false
		};
		return _this2;
	}

	(0, _createClass3.default)(Dropdown, [{
		key: "toggle",
		value: function toggle() {
			var _this3 = this;

			this.setState(function (pState) {
				return { active: !pState.active };
			}, function () {
				_this3.dropdownContentRef.scrollHeight - _this3.dropdownContentRef.clientHeight - _this3.dropdownContentRef.scrollTop === 0 && _this3.setState({ scrolled: true });
			});
		}
	}, {
		key: "show",
		value: function show() {
			this.setState({ active: true });
		}
	}, {
		key: "hide",
		value: function hide() {
			this.setState({ active: false });
		}
	}, {
		key: "onClickOption",
		value: function onClickOption(e) {
			this.hide();
			this.props.onChange(e);
		}
	}, {
		key: "handleClickOutside",
		value: function handleClickOutside() {
			this.hide();
		}

		//Scrolling

	}, {
		key: "onWrapperScroll",
		value: function onWrapperScroll(e) {
			if (e.target.scrollHeight - e.target.clientHeight - e.target.scrollTop === 0) {
				this.setState({ scrolled: true });
			} else {
				this.state.scrolled && this.setState({ scrolled: false });
			}
		}
	}, {
		key: "componentDidMount",
		value: function componentDidMount() {
			var dropdownContent = _reactDom2.default.findDOMNode(this.dropdownContentRef);
			dropdownContent.addEventListener("scroll", this.onWrapperScroll);
		}
	}, {
		key: "componentWillUnmount",
		value: function componentWillUnmount() {
			var dropdownContent = _reactDom2.default.findDOMNode(this.dropdownContentRef);
			dropdownContent.removeEventListener("scroll", this.onWrapperScroll);
		}
	}, {
		key: "onDropdownContentRef",
		value: function onDropdownContentRef(ref) {
			this.dropdownContentRef = ref || this.dropdownContentRef;
		}
	}, {
		key: "render",
		value: function render() {
			var _this4 = this;

			var _props = this.props,
			    label = _props.label,
			    value = _props.value,
			    children = _props.children;


			return _react2.default.createElement(
				OuterWrapper,
				null,
				label && _react2.default.createElement(
					Label,
					null,
					label
				),
				_react2.default.createElement(
					Wrapper,
					null,
					_react2.default.createElement(
						Trigger,
						{ onClick: this.toggle },
						value >= 1 ? (children.find(function (o) {
							return value === o.props.value || value === o.props.children;
						}) || children[0]).props.children : this.props.default || "Choose..."
					),
					_react2.default.createElement(
						Content,
						(0, _extends3.default)({
							innerRef: this.onDropdownContentRef,
							className: this.state.scrolled ? "scrolled" : null
						}, this.state),
						this.props.children && this.props.children.length > 0 ? _react2.default.Children.map(children, function (_ref, i) {
							var optionProps = _ref.props;
							return _react2.default.createElement(DropdownOption, (0, _extends3.default)({
								key: i
							}, optionProps, {
								onClick: _this4.onClickOption,
								active: value === optionProps.value
							}));
						}) : _react2.default.createElement(
							Option,
							{ onClick: this.hide },
							"No options supplied"
						)
					)
				)
			);
		}
	}]);
	return Dropdown;
}(_react2.default.Component), (_applyDecoratedDescriptor(_class3.prototype, "toggle", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class3.prototype, "toggle"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "show", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class3.prototype, "show"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "hide", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class3.prototype, "hide"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "onClickOption", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class3.prototype, "onClickOption"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "handleClickOutside", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class3.prototype, "handleClickOutside"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "onWrapperScroll", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class3.prototype, "onWrapperScroll"), _class3.prototype), _applyDecoratedDescriptor(_class3.prototype, "onDropdownContentRef", [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class3.prototype, "onDropdownContentRef"), _class3.prototype)), _class3)) || _class2;

var Blank = function Blank(props) {
	return _react2.default.createElement("div", props);
};

Dropdown.Option = Blank;

Dropdown.Trigger = function (props) {
	return _react2.default.createElement(Option, (0, _extends3.default)({}, props, { trigger: true }));
};

// --------------------------------------------------

Dropdown.Old = function (props) {
	return _react2.default.createElement(
		"form",
		null,
		_react2.default.createElement(
			"select",
			{ value: props.value, onChange: props.onChange },
			props.children
		)
	);
};

Dropdown.Old.Option = function (props) {
	return _react2.default.createElement(
		"option",
		{ value: props.value },
		props.children
	);
};

// --------------------------------------------------

exports.default = Dropdown;

//# sourceMappingURL=dropdown.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/dropdown.js
// module id = 371
// module chunks = 0